import styled from 'styled-components';
import { NavLink } from 'react-router-dom';

export const NameBlock = styled.div`
  width: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const TemplateNameBlock = styled.div`
  width: 60%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 0px auto;
  padding-left: 40px;
`;

export const Label = styled.label`
  min-width: 150px;
  font-size: 20px;
  cursor: pointer;
  // margin: 10px;
`;

export const PeriodLabel = styled.label`
  min-width: 50px;
  font-size: 15px;
`;

export const H1 = styled.h1`
  text-align: center;
  font-size: 20px;
  margin-top: 25px;
`;
export const H2 = styled.h1`
  text-align: center;
  font-size: 22px;
  margin-top: 10px;
`;
export const Content = styled.div`
  width: 55%;
  margin: 0px auto;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding-left: 50px;
  // margin-bottom: 40px;
  padding-bottom: 40px;
`;
export const DishCountBlock = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 30px auto;
`;

export const CreateUserButton = styled.div`
  width: 30%;
  margin-left: 10px;
`;

export const TypeComplexityBlock = styled.div`
  //   width: 80%;
  display: flex;
  //   flex-direction: row;
  //   justify-content: center;
  align-items: center;
`;

export const Block = styled.div`
  margin: 10px;
  display: flex;
  flex-direction: column;
`;
export const Item = styled.div`
  width: 100%;
  margin: 8px auto;
  display: flex;
  justify-content: flex-start;
`;

export const TableBlock = styled.div`
  width: 60%;
  display: flex;
  justify-content: center;
  margin: 0 auto;
`;

export const PlayButton = styled.div`
  background: green;
  width: 25px;
  height: 25px;
  box-sizing: border-box;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  color: #fff;
  border: 1px solid #000542;
  border-radius: 5px;
  text-transform: uppercase;
  margin: 5px;
  &:hover {
    background: blue;
    border: 1px solid #000542;
  }
  @media (max-width: 992px) {
    width: 20px;
    height: 20px;
  }
`;



// WEBPACK FOOTER //
// ./src/Components/YouSlim2.0/CreateTrainingTemplate/TrainingTemplate.js